function product_features_slider_fancy(link, titles) {
  if (jQuery(window).width() > 991) {
    jQuery(".product_features_items_slider ul").slick("slickPause")
  }
  jQuery("#product_features_slider_fancy img").attr("src", link)

  jQuery.fancybox.open({
    src: "#product_features_slider_fancy",
    caption: titles,
    helpers: {
      title: {
        type: "inside",
        position: "top",
      },
    },
    afterClose: function () {
      jQuery("#product_features_slider_fancy img").attr("src", "")
      if (jQuery(window).width() > 991) {
        jQuery(".product_features_items_slider ul").slick("slickPlay")
      }
    },
  })
}

function openCity(evt, cityName) {
  jQuery(".product-title").removeClass("active")
  jQuery("#buts_" + cityName).addClass("active")
  jQuery(".product-text").css("display", "none")
  jQuery("#item_" + cityName).fadeIn(1000)

  const $navItems = document.querySelector(".product-title_wrap")
  const $navItemActive = document.querySelector(".active")
}

function multi_gallery_v2_slider_fancy(link, titles) {
  if (jQuery(window).width() > 991) {
    jQuery(".multi_gallery_v2_slider ul").slick("slickPause")
  }
  jQuery("#multi_gallery_v2_slider_fancy img").attr("src", link)

  jQuery.fancybox.open({
    src: "#multi_gallery_v2_slider_fancy",
    caption: titles,
    helpers: {
      title: {
        type: "inside",
        position: "top",
      },
    },
    afterClose: function () {
      jQuery("#multi_gallery_v2_slider_fancy img").attr("src", "")
      if (jQuery(window).width() > 991) {
        jQuery(".multi_gallery_v2_slider ul").slick("slickPlay")
      }
    },
  })
}

function homepage_science_slider_fancy(link, titles) {
  if (jQuery(window).width() > 767) {
    jQuery(".homepage_science_items_slider ul").slick("slickPause")
  }
  jQuery("#homepage_science_slider_fancy img").attr("src", link)

  jQuery.fancybox.open({
    src: "#homepage_science_slider_fancy",
    caption: titles,
    helpers: {
      title: {
        type: "inside",
      },
    },
    afterClose: function () {
      jQuery("#homepage_science_slider_fancy img").attr("src", "")
      if (jQuery(window).width() > 767) {
        jQuery(".homepage_science_items_slider ul").slick("slickPlay")
      }
    },
  })
}

function vest_science_slider_fancy(link, titles) {
  if (jQuery(window).width() > 767) {
    jQuery(".vest_science_items_slider ul").slick("slickPause")
  }
  jQuery("#vest_science_slider_fancy img").attr("src", link)

  jQuery.fancybox.open({
    src: "#vest_science_slider_fancy",
    caption: titles,
    helpers: {
      title: {
        type: "inside",
      },
    },
    afterClose: function () {
      jQuery("#vest_science_slider_fancy img").attr("src", "")
      if (jQuery(window).width() > 767) {
        jQuery(".vest_science_items_slider ul").slick("slickPlay")
      }
    },
  })
}

function reason_slider_slider_fancy(link, titles) {
  if (jQuery(window).width() > 991) {
    jQuery(".reason_slider_items_slider ul").slick("slickPause")
  }
  jQuery("#reason_slider_slider_fancy img").attr("src", link)

  jQuery.fancybox.open({
    src: "#reason_slider_slider_fancy",
    caption: titles,
    helpers: {
      title: {
        type: "inside",
        position: "top",
      },
    },
    afterClose: function () {
      jQuery("#reason_slider_slider_fancy img").attr("src", "")
      if (jQuery(window).width() > 991) {
        jQuery(".reason_slider_items_slider ul").slick("slickPlay")
      }
    },
  })
}

jQuery(document).ready(function ($) {
  $(window).scroll(function () {
    let height = jQuery(document).height()
    let h = height / 2
    if (h < 0) h = 0
    if ($(this).scrollTop() > h) {
      $("#scroller").fadeIn()
    } else {
      $("#scroller").fadeOut()
    }
  })
  $("#scroller").click(function () {
    $("body,html").animate({ scrollTop: 0 }, 500)
    $("#scroller").blur()
    return false
  })
})

function show_watch_the_xray() {
  if (jQuery(".watch_the_xray").hasClass("active")) {
    jQuery(".watch_the_xray").removeClass("active")
    jQuery("#watch_the_xray").html("See xray")
    jQuery(".main_product__image_slider").css("display", "flex")
    jQuery(".mob_twentytwenty-wrap").css("display", "none")
    var $this = jQuery(".twentytwenty_block_mob")

    $this.find(".twentytwenty-overlay").remove()
    $this.find(".twentytwenty-handle").remove()
    $this
      .find("img")
      .removeClass("twentytwenty-before")
      .removeClass("twentytwenty-after")
      .each(function () {
        this.style.removeProperty("clip")
      })
    $this.unwrap(".twentytwenty-wrapper")
    $this
      .off("touchmove.twentytwenty")
      .off("mousedown.twentytwenty")
      .off("mouseleave.twentytwenty")
      .off("mousemove.twentytwenty")
      .off("movestart.twentytwenty")
      .off("move.twentytwenty")
      .off("moveend.twentytwenty")
  } else {
    jQuery(".watch_the_xray").addClass("active")
    jQuery("#watch_the_xray").html("Close xray")
    jQuery(".main_product__image_slider").css("display", "none")
    jQuery(".mob_twentytwenty-wrap").css("display", "block")
    jQuery(".twentytwenty_block_mob").twentytwenty()
    var imgWidth = jQuery(".twentytwenty_block_mob img").width() / 2
    var imgWidth_full = jQuery(".twentytwenty_block_mob img").width()

    jQuery(".twentytwenty_block_mob").css({ width: imgWidth_full + "px", left: "calc(50% - " + imgWidth + "px)" })
  }
}

function header_scroll() {
  let height = 85
  if (jQuery(".header_announement").length) {
    height = 10
  }

  if (jQuery(document).scrollTop() >= height) {
    jQuery(".header").addClass("active")
  } else {
    jQuery(".header").removeClass("active")
  }
  /*
   if (jQuery('.sticky_add_to_cart').length) {
     if (jQuery(document).scrollTop() >= 800) {
       jQuery('.sticky_add_to_cart').addClass('active');
     } else {
      jQuery('.sticky_add_to_cart').removeClass('active'); 
     }
   }
   */
}

function show_sub_menu(id) {
  jQuery(".home-menu-block_menu").css("display", "none")
  jQuery("#show_" + id).css("display", "block")
}

function show_cats(id) {
  jQuery(".our_customes_dann_cats span").removeClass("active")
  jQuery("#cat_" + id).addClass("active")
  if (id != "all") {
    jQuery(".our_customes_dann_blocks .item").css("display", "none")
    jQuery(".our_customes_dann_blocks .show_" + id).css("display", "grid")
  } else {
    jQuery(".our_customes_dann_blocks .item").css("display", "grid")
  }
}

function validateEmail(email) {
  var reg = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

function urlParam(name) {
  var results = []
  results = new RegExp("[\\?&]" + name + "=([^&#]*)").exec(window.location.href)
  var ret = 0
  if (results != null) {
    if (1 in results) {
      ret = results[1]
    }
  }
  return ret
}

function close_sidebar_cart() {
  jQuery("#block_sidebar_cart").removeClass("active")
  jQuery("body").removeClass("overflow-hidden")
  var origin = window.location.href
  var result = origin.split("#")
  history.pushState({}, null, result[0])
}

function show_product_slider() {
  var $carousel = jQuery(".main_product__image_slider")

  if (jQuery(window).width() < 768) {
    if ($carousel.hasClass("slick-initialized")) {
    } else {
      jQuery(".main_product__image_slider .twentytwenty-wrap").remove()
      $carousel.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: false,
        infinite: false,
        speed: 600,
        focusOnSelect: true,
      })
    }
  } else {
    if ($carousel.hasClass("slick-initialized")) {
      $carousel.slick("unslick")
    }
  }
}

//
function category_filters() {
  if (jQuery(".collection_fixed_block").length) {
    if (jQuery(window).width() > 991) {
      let to_block = jQuery(".collection_fixed_block").position().top
      let heg_header = jQuery(".header").height()
      if (jQuery(document).scrollTop() > to_block) {
        jQuery(".collection_fixed_block").addClass("focus_active")
      } else {
        jQuery(".collection_fixed_block").removeClass("focus_active")
      }
    } else {
      jQuery(".collection_fixed_block").removeClass("focus_active")
    }
  }
}

function best_slider_wrapper() {
  if (jQuery(window).width() >= 767) {
    if (jQuery(".best-slider_wrapper").hasClass("slick-initialized")) {
    } else {
      jQuery(".best-slider_wrapper").slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        dots: true,
        autoplay: false,
        infinite: true,
        speed: 600,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
        prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="far fa-arrow-left"></i></button>',
        nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="far fa-arrow-right"></i></button>',
      })
    }
  } else {
    if (jQuery(".best-slider_wrapper").hasClass("slick-initialized")) {
      jQuery(".best-slider_wrapper").slick("unslick")
    }
  }
}

jQuery(document).ready(function ($) {
  header_scroll()
  category_filters()
  if ($(".best-slider_wrapper").length > 0) {
    best_slider_wrapper()
  }
  $(window).scroll(function () {
    header_scroll()
    category_filters()
  })
  $(window).resize(function () {
    header_scroll()
    category_filters()
    if ($(".best-slider_wrapper").length > 0) {
      best_slider_wrapper()
    }
  })

  var get_url = window.location.href
  if (get_url.indexOf("minicart=open") > 0) {
    $("#block_sidebar_cart").addClass("active")
    jQuery("body").addClass("overflow-hidden")
  }
  /*
  var position_footer = $('.footer_block').position().top
  var w_h = $(window).height() / 2
  if ($(window).width() > 1600) {
    $('.footer_logo_img').addClass('scroll')
    var position_l = $(document).scrollTop() + w_h
  
    if (position_l >= position_footer) {
      $('.footer_logo_img').removeClass('no_active')
    } else {
      $('.footer_logo_img').addClass('no_active')
    }
  } else {
    $('.footer_logo_img').removeClass('no_active')
    $('.footer_logo_img').addClass('scroll')
  }

  $(window).resize(function () {
    var position_footer = $('.footer_block').position().top
    if ($(window).width() > 1600) {
      $('.footer_logo_img').addClass('scroll')
      var position_l = $(document).scrollTop() + w_h
      if (position_l >= position_footer) {
        $('.footer_logo_img').removeClass('no_active')
      } else {
        $('.footer_logo_img').addClass('no_active')
      }
    } else {
      $('.footer_logo_img').removeClass('no_active')
      $('.footer_logo_img').addClass('scroll')
    }
  })

  $(window).scroll(function () {
    if ($(window).width() > 1600) {
      $('.footer_logo_img').addClass('no_active')
      $('.footer_logo_img').addClass('scroll')
      var position_l = $(document).scrollTop() + w_h
      
      if (position_l >= position_footer) {
        $('.footer_logo_img').removeClass('no_active')
      } else {
        $('.footer_logo_img').addClass('no_active')
      }
    } else {
      $('.footer_logo_img').removeClass('no_active')
    }
  })
*/
  /*
   $('#sidebar-cart-bg').on('click', function (event) {
    jQuery('#block_sidebar_cart').removeClass('active');
  jQuery('body').removeClass('overflow-hidden')
  var origin   = window.location.href;
  var result = origin.split('#');
   history.pushState({}, null, result[0]); 
  })
*/
  $(".home-menu-block_menu_sub_back").on("click", function (event) {
    jQuery(".home-menu-block_menu_sub").css("display", "none")
    jQuery(".home-menu-block_menu").css("display", "block")
  })

  $(".footer__links_item .h4").on("click", function (event) {
    if ($(window).width() < 576) {
      let id = $(this).data("id")
      if ($(this).hasClass("active")) {
        $(this).removeClass("active")
        $("#footer_item_menu_" + id).slideUp()
      } else {
        $(this).addClass("active")
        $("#footer_item_menu_" + id).slideDown()
      }
    } else {
      $(".footer__links_item .h4").removeClass("active")
      $(".footer__links_item_menu").slideDown()
    }
  })

  $(window).resize(function () {
    if ($(window).width() > 575) {
      $(".footer__links_item .h4").removeClass("active")
      $(".footer__links_item_menu").slideDown()
    }
  })

  $(".search_block_ico").click(function () {
    $(".search-modal").addClass("active")
    $("body").addClass("overflow-hidden")
    $("#Search-In-Modal").focus()
  })
  $(".search-modal__close-button").click(function () {
    $(".search-modal").removeClass("active")
    $("body").removeClass("overflow-hidden")
  })

  jQuery(document).ready(function ($) {
    $(".size_guide-title_wrap").click(function () {
      $.fancybox.open({ src: "#size_guide", contentClick: false, dragToClose: false, touch: false })
    })
    //amazon popup in pdp
    $(".amazon_popup-link").click(function () {
      $.fancybox.open({ src: $(this).attr("href"), contentClick: false, dragToClose: false, touch: false })
    })
    $(".amazon_popup-close").click(function () {
      $.fancybox.close({ src: $(this).attr("href"), contentClick: false, dragToClose: false, touch: false })
    })
  })

  jQuery(function () {
    jQuery(".size_guide.mens_tops").on("click", function () {
      jQuery(".product-title").removeClass("active")
      jQuery("#buts_1" + ".product-title").addClass("active")
      jQuery(".product-text").css("display", "none")
      jQuery("#item_1" + ".product-text").css("display", "block")
    })
  })

  jQuery(function () {
    jQuery(".size_guide.mens_pants").on("click", function () {
      jQuery(".product-title").removeClass("active")
      jQuery("#buts_2" + ".product-title").addClass("active")
      jQuery(".product-text").css("display", "none")
      jQuery("#item_2" + ".product-text").css("display", "block")
    })
  })

  jQuery(function () {
    jQuery(".size_guide.mens_shorts").on("click", function () {
      jQuery(".product-title").removeClass("active")
      jQuery("#buts_3" + ".product-title").addClass("active")
      jQuery(".product-text").css("display", "none")
      jQuery("#item_3" + ".product-text").css("display", "block")
    })
  })

  jQuery(function () {
    jQuery(".size_guide.accessories").on("click", function () {
      jQuery(".product-title").removeClass("active")
      jQuery("#buts_4" + ".product-title").addClass("active")
      jQuery(".product-text").css("display", "none")
      jQuery("#item_4" + ".product-text").css("display", "block")
    })
  })

  jQuery(function () {
    jQuery(".size_guide.womens_tops").on("click", function () {
      jQuery(".product-title").removeClass("active")
      jQuery("#buts_1" + ".product-title").addClass("active")
      jQuery(".product-text").css("display", "none")
      jQuery("#item_1" + ".product-text").css("display", "block")
    })
  })

  jQuery(function () {
    jQuery(".size_guide.womens_pants").on("click", function () {
      jQuery(".product-title").removeClass("active")
      jQuery("#buts_2" + ".product-title").addClass("active")
      jQuery(".product-text").css("display", "none")
      jQuery("#item_2" + ".product-text").css("display", "block")
    })
  })

  jQuery(function () {
    jQuery(".size_guide.womens_dresses_skirts").on("click", function () {
      jQuery(".product-title").removeClass("active")
      jQuery("#buts_3" + ".product-title").addClass("active")
      jQuery(".product-text").css("display", "none")
      jQuery("#item_3" + ".product-text").css("display", "block")
    })
  })

  $(".expandable-information_details").on("click", function () {
    if (!$(this).hasClass("active")) {
      $(this).next().slideDown()
      $(".expandable-information_details.active").next().stop().slideUp()
      $(".expandable-information_details.active").removeClass("active")
      $(this).addClass("active")
    } else {
      $(this).removeClass("active")
      $(this).next().stop().slideUp()
    }
  })

  if ($(".main_product__image_slider").length > 0) {
    show_product_slider()
    $(window).resize(function () {
      show_product_slider()
    })
  }
  if ($(".twentytwenty_block").length > 0) {
    setTimeout(function () {
      $(".twentytwenty_block").twentytwenty()
      $(".twentytwenty_block img").css("display", "block")
    }, 2000)
  }
  if ($(".product_pockets_block_slider").length > 0) {
    $(".product_pockets_block_slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: false,
      infinite: false,
      speed: 600,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    })
  }
  if ($(".faq-block").length > 0) {
    $(".faq-block details").click(function () {
      $(".faq-block details").not(this).removeAttr("open")
      var attr = $(this).attr("open")
      if (typeof attr !== "undefined" && attr !== false) {
        history.pushState({}, null, "?")
      } else {
        var id = $(this).data("id")
        history.pushState({}, null, "?item=" + id)
        $("html, body").animate(
          {
            scrollTop: $("#details_id_" + id).offset().top - 100,
          },
          500
        )
      }
    })
  }

  if ($(".loyalty_program_block").length > 0) {
    $(".loyalty_program_block details").click(function () {
      $(".loyalty_program_block details").not(this).removeAttr("open")
      var attr = $(this).attr("open")
      if (typeof attr !== "undefined" && attr !== false) {
        history.pushState({}, null, "?")
      } else {
        var id = $(this).data("id")
        history.pushState({}, null, "?item=" + id)
        $("html, body").animate(
          {
            scrollTop: $("#details_id_" + id).offset().top,
          },
          0
        )
      }
    })
  }

  if ($(".questions-section_block").length > 0) {
    $(".questions-section_block details").click(function () {
      $(".questions-section_block details").not(this).removeAttr("open")
      var attr = $(this).attr("open")
      if (typeof attr !== "undefined" && attr !== false) {
        history.pushState({}, null, "?")
      } else {
        var id = $(this).data("id")
        history.pushState({}, null, "?item=" + id)
        $("html, body").animate(
          {
            scrollTop: $("#details_id_" + id).offset().top - 100,
          },
          500
        )
      }
    })
  }

  if ($(".product_gallery_block__slider").length > 0) {
    $(".product_gallery_block__slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: false,
      infinite: true,
      speed: 600,
      focusOnSelect: true,
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="far fa-arrow-left"></i></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="far fa-arrow-right"></i></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    })
  }

  $(".collection-filter-cat-current").click(function () {
    if ($(".collection__list_menu").hasClass("active")) {
      $(".collection__list_menu").removeClass("active")
    } else {
      $(".collection__list_menu").addClass("active")
    }
  })

  $(".variant_color_circle").mouseenter(function () {
    var image = $(this).data("image")
    var id = $(this).data("id")
    if (image != "") {
      $("#product_item_" + id + " .collection__image_variation").html('<img src="https:' + image + '">')
      $("#product_item_" + id + " .collection__image_variation").css("z-index", "5")
    }
  })

  $(".variant_color_circle").mouseleave(function () {
    $(".product-grid_item .collection__image_variation").html("")
    $(".product-grid_item .collection__image_variation").css("z-index", "0")
  })

  $(".full_main_product_image .product__media-toggle").mouseenter(function () {
    let hover_img = $(".full_main_product_image .main_hover_image").attr("src")
    if (hover_img != "") {
      $(".full_main_product_image .main_hover_image").css("opacity", "1")
      $(".full_main_product_image .main_hover_image").css("z-index", "2")
      $(".full_main_product_image .main_hover_image").css("display", "block")
      $(".full_main_product_image .main_image").css("z-index", "1")
    } else {
      $(".full_main_product_image .main_hover_image").css("opacity", "0")
    }
    /*
    var image = $(this).data('hoverimage') 
    if (image != '') {
      $(
        '.main_product__image_slider .main_product_image .product__media img',
      ).attr('src', image)
      $(
        '.main_product__image_slider .main_product_image .product__media img',
      ).attr('srcset', image)
      $(
        '.main_product__image_slider .main_product_image .product__media source',
      ).attr('src', image)
    }
    */
  })

  $(".full_main_product_image .product__media-toggle").mouseleave(function () {
    $(".full_main_product_image .main_image").css("z-index", "2")
    $(".full_main_product_image .main_hover_image").css("z-index", "1")
    $(".full_main_product_image .main_hover_image").css("display", "none")
    /*
    var image = $(this).data('oldimage')
    if (image != '') {
      $(
        '.main_product__image_slider .main_product_image .product__media img',
      ).attr('src', image)
      $(
        '.main_product__image_slider .main_product_image .product__media img',
      ).attr('srcset', image)
      $(
        '.main_product__image_slider .main_product_image .product__media source',
      ).attr('src', image)
    }
    */
  })

  $("#hamburger_header").click(function () {
    if ($(this).hasClass("is-active")) {
      $(".bg").removeClass("active")
      $(".header__nav").removeClass("active")
      $(".mob_bg").removeClass("active")
      $("#hamburger_header").removeClass("is-active")
      jQuery("body").removeClass("overflow-hidden")
      $("#cb-announement-bar").removeClass("announement-hidden")
    } else {
      $(".bg").addClass("active")
      $(".header__nav").addClass("active")
      $(".mob_bg").addClass("active")
      $("#hamburger_header").addClass("is-active")
      jQuery("body").addClass("overflow-hidden")
      $("#cb-announement-bar").addClass("announement-hidden")
    }
  })

  $("#hamburger_header_mob").click(function () {
    $(".bg").removeClass("active")
    $(".header__nav").removeClass("active")
    $(".mob_bg").removeClass("active")
    $("#hamburger_header").removeClass("is-active")
    jQuery("body").removeClass("overflow-hidden")
    $("#cb-announement-bar").removeClass("announement-hidden")
  })

  $(".mob_bg").click(function () {
    $(".bg").removeClass("active")
    $(".header__nav").removeClass("active")
    $(".mob_bg").removeClass("active")
    $("#hamburger_header").removeClass("is-active")
    jQuery("body").removeClass("overflow-hidden")
    $("#cb-announement-bar").removeClass("announement-hidden")
  })

  function clickSubmenuMobileSHow(){
    $(".header__menu .child span").click(function () {
      
      var p_li = $(this).parent(".child")
      if (p_li.hasClass("selected")) {
        p_li.removeClass("selected")
      } else {
        p_li.addClass("selected")
      }
  
    })
     $(".header__menu .child span a").click(function (e) {
     e.preventDefault();
    })
  }
  /*$(window).resize(function() {
      if ($(window).width() < 1201) {
        clickSubmenuMobileSHow()
      }
  });*/
  
  if($(window).width() < 1201){
    clickSubmenuMobileSHow()
  }


  $(".product-form__input__color label").click(function () {
    var name = $(this).data("name")
    var image = $(this).data("image")
    var hover_image = $(this).data("hoverimage")
    var name_color = $("#contact_color").val()
    if (image != "") {
      /*
      $('.main_product_image img').attr('src', image)
       $('.main_product_image a').attr('href', image)
      $('.main_product_image img').attr('srcset', image)
      $('.main_product_image source').attr('src', image)
      
      
      $('.full_main_product_image .product__media-toggle').data(
        'oldimage',
        image,
      )
      */
      $(".product-media-modal__content .main_product_image img").attr("src", image)
      $(".main_product_image .main_image").attr("src", image)
      $(".main_product_image a").attr("href", image)
      /*
      $('.full_main_product_image .product__media-toggle').data(
        'oldimage',
        image,
      )
      */
    }

    if (hover_image != "") {
      /*
      $('.full_main_product_image .product__media-toggle').data(
        'hoverimage',
        hover_image,
      )
      */
      $(".main_product_image .main_hover_image").attr("src", hover_image)
      $(".main_product_image .main_hover_image").css("display", "none")
      $(".main_product_image .main_hover_image").css("z-index", "1")
      $(".main_product_image .main_hover_image").css("opacity", "1")
    } else {
      $(".main_product_image .main_hover_image").attr("src", "")
      $(".main_product_image .main_hover_image").css("display", "none")
      $(".main_product_image .main_hover_image").css("z-index", "1")
      $(".main_product_image .main_hover_image").css("opacity", "0")
    }

    $(".product-form__input__size input").prop("disabled", false)
    $(".product_stock_form_inputs input").prop("disabled", false)
    $(".product_stock_form_inputs input").prop("checked", false)
    var count_noavailable = 0
    var color = ""
    $(".product_select__select > option").each(function () {
      var option1 = $(this).data("option1")
      var option2 = $(this).data("option2")
      var available = $(this).data("available")
      if (name == option1) {
        color = $(this).data("color")
        if (available == false) {
          $(".input__size_" + option2).prop("disabled", true)
          count_noavailable++
        } else {
          $(".input__stock_" + option2).prop("disabled", true)
        }
      }
    })
    $("#contact_color").val(color)

    if (count_noavailable == 0) {
      $(".product_stock_link").addClass("nones")
    } else $(".product_stock_link").removeClass("nones")

    $(".product-form__input__size input").each(function () {
      if ($(this).prop("checked") == true) {
        if ($(this).prop("disabled") == true) {
          $(".product-form__submit span").html("Sold out")
        } else $(".product-form__submit span").html("Add to cart")
      }
    })

    if ($(".main_product__image_slider").hasClass("slick-initialized")) {
      if (jQuery(".watch_the_xray").hasClass("active")) {
        jQuery(".watch_the_xray").removeClass("active")
        jQuery("#watch_the_xray").html("Watch the xray")
        jQuery(".main_product__image_slider").css("display", "flex")
        jQuery(".mob_twentytwenty-wrap").css("display", "none")
        var $this = jQuery(".twentytwenty_block_mob")

        $this.find(".twentytwenty-overlay").remove()
        $this.find(".twentytwenty-handle").remove()
        $this
          .find("img")
          .removeClass("twentytwenty-before")
          .removeClass("twentytwenty-after")
          .each(function () {
            this.style.removeProperty("clip")
          })
        $this.unwrap(".twentytwenty-wrapper")
        $this
          .off("touchmove.twentytwenty")
          .off("mousedown.twentytwenty")
          .off("mouseleave.twentytwenty")
          .off("mousemove.twentytwenty")
          .off("movestart.twentytwenty")
          .off("move.twentytwenty")
          .off("moveend.twentytwenty")
      }

      $(".main_product__image_slider").slick("slickGoTo", 0)
    }
  })

  $(".product-form__submit").click(function () {
    var variant_id = $("#current_variant_id").val()

    var data = {
      id: variant_id,
      quantity: 1,
    }
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        $.getJSON("/cart.js", function (cart, textStatus) {
          $("#cart_count").html(cart.item_count)
        })

        return fetch("/cart?view=drawer&timestamp=" + Date.now(), {
          credentials: "same-origin",
          method: "GET",
        }).then(function (content) {
          content.text().then(function (html) {
            $("#block_sidebar_cart").html(html)
            $("#block_sidebar_cart").addClass("active")
            jQuery("body").addClass("overflow-hidden")
          })
          history.pushState({}, null, "#minicart=open")
        })
      },
    })
  })

  $(".header__icon--cart").click(function (event) {
    event.preventDefault()
    $("#block_sidebar_cart").addClass("active")
    $("body").addClass("overflow-hidden")
    history.pushState({}, null, "#minicart=open")
  })

  $("#Notifyme").submit(function () {
    return false
  })
  $("#notify-submit").on("click", function () {
    var $form = $("#Notifyme")
    $form.find(".form-errors").fadeOut()
    $form.find(".form-successfully").fadeOut()
    jQuery.ajax({
      crossDomain: true,
      type: "POST",
      async: true,
      url: "/contact",
      data: $form.serialize(),
      beforeSend: function () {
        $form.addClass("sending")
      },
      error: function (t) {
        $form.addClass("sent")
        $form.find(".form-errors").fadeIn()
      },
      success: function (response) {
        $form.addClass("sent")
        $form.find(".form-successfully").fadeIn()
      },
    })
  })

  $("#request_refund").submit(function () {
    return false
  })
  $("#request_refund_submit").on("click", function () {
    var $form = $("#request_refund")
    $form.find(".form-errors").fadeOut()
    $form.find(".form-successfully").fadeOut()
    var err = 0
    var phone = $("#phone1").val()
    if (phone == "") {
      $("#phone1").addClass("error")
      err++
    } else $("#phone1").removeClass("error")

    var emailval = $("#email1").val()
    var mailvalid = validateEmail(emailval)
    if (mailvalid == false) {
      $("#email1").addClass("error")
      err++
    } else $("#email1").removeClass("error")

    var returns1 = $("#items-returns1").val()
    if (returns1 == "") {
      $("#items-returns1").addClass("error")
      err++
    } else $("#items-returns1").removeClass("error")

    var selected_option = $("#reason_return1 option:selected").val()
    if (selected_option != "") {
      $("#reason_return1").removeClass("error")
    } else {
      $("#reason_return1").addClass("error")
      err++
    }

    var address1 = $("#name-address1").val()
    if (address1 == "") {
      $("#name-address1").addClass("error")
      err++
    } else $("#name-address1").removeClass("error")

    if ($("#agreement1").is(":checked")) {
      $("#agreement1").removeClass("error")
    } else {
      $("#agreement1").addClass("error")
      err++
    }

    if (err == 0) {
      jQuery.ajax({
        crossDomain: true,
        type: "POST",
        async: true,
        url: "/contact",
        data: $form.serialize(),
        beforeSend: function () {
          $form.addClass("sending")
        },
        error: function (t) {
          $form.addClass("sent")
          $form.find(".form-errors").fadeIn()
        },
        success: function (response) {
          $form.addClass("sent")
          $form.find(".form-successfully").fadeIn()
          $form.trigger("reset")
        },
      })
    }
  })

  $("#request_exchange").submit(function () {
    return false
  })
  $("#request_exchange_submit").on("click", function () {
    var $form = $("#request_exchange")
    $form.find(".form-errors").fadeOut()
    $form.find(".form-successfully").fadeOut()
    var err = 0
    var phone = $("#phone2").val()
    if (phone == "") {
      $("#phone2").addClass("error")
      err++
    } else $("#phone2").removeClass("error")

    var emailval = $("#email2").val()
    var mailvalid = validateEmail(emailval)
    if (mailvalid == false) {
      $("#email2").addClass("error")
      err++
    } else $("#email2").removeClass("error")

    var returns1 = $("#items-returns2").val()
    if (returns1 == "") {
      $("#items-returns2").addClass("error")
      err++
    } else $("#items-returns2").removeClass("error")

    var selected_option = $("#reason_return2 option:selected").val()
    if (selected_option != "") {
      $("#reason_return2").removeClass("error")
    } else {
      $("#reason_return2").addClass("error")
      err++
    }

    var desired2 = $("#items-desired2").val()
    if (desired2 == "") {
      $("#items-desired2").addClass("error")
      err++
    } else $("#items-desired2").removeClass("error")

    var selected_option = $("#payment-method2 option:selected").val()
    if (selected_option != "") {
      $("#payment-method2").removeClass("error")
    } else {
      $("#payment-method2").addClass("error")
      err++
    }

    var address = $("#name-address2").val()
    if (address == "") {
      $("#name-address2").addClass("error")
      err++
    } else $("#name-address2").removeClass("error")

    if ($("#agreement2").is(":checked")) {
      $("#agreement2").removeClass("error")
    } else {
      $("#agreement2").addClass("error")
      err++
    }

    if (err == 0) {
      jQuery.ajax({
        crossDomain: true,
        type: "POST",
        async: true,
        url: "/contact",
        data: $form.serialize(),
        beforeSend: function () {
          $form.addClass("sending")
        },
        error: function (t) {
          $form.addClass("sent")
          $form.find(".form-errors").fadeIn()
        },
        success: function (response) {
          $form.addClass("sent")
          $form.find(".form-successfully").fadeIn()
          $form.trigger("reset")
        },
      })
    }
  })

  if ($(".our_story_customers_slider").length > 0) {
    $(".our_story_customers_slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: false,
      infinite: true,
      speed: 600,
      focusOnSelect: true,
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="far fa-arrow-left"></i></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="far fa-arrow-right"></i></button>',
    })
  }

  if ($(".group-slider-block").length > 0) {
    $(".group-slider-block").slick({
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: true,
      speed: 600,
      focusOnSelect: true,
      variableWidth: true,
      asNavFor: ".group-slider-dots-slider",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            dots: true,
          },
        },
        {
          breakpoint: 575,
          settings: {
            dots: true,
            slidesToShow: 1,
            variableWidth: false,
          },
        },
      ],
    })

    $(".group-slider-dots-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".group-slider-block",
      arrows: false,
      dots: true,
    })
  }

  if ($(".media-slider").length > 0) {
    $(".media-slider").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: false,
      speed: 600,
      focusOnSelect: true,
      asNavFor: ".media-slider-dots-slider",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            dots: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    })

    $(".media-slider-dots-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".media-slider",
      arrows: false,
      dots: true,
    })
  }

  if ($(".vest-wrapper").length > 0) {
    $(".vest-wrapper").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: false,
      speed: 600,
      focusOnSelect: true,
      asNavFor: ".vest-wrapper-dots",
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            dots: true,
          },
        },
        {
          breakpoint: 567,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    })

    $(".vest-wrapper-dots").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".vest-wrapper",
      arrows: false,
      dots: true,
    })
  }

  if ($(".vest-wrapper-dop").length > 0) {
    $(".vest-wrapper-dop").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: false,
      speed: 600,
      focusOnSelect: true,
      asNavFor: ".vest-wrapper-dots-dop",
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            dots: true,
          },
        },
        {
          breakpoint: 567,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    })

    $(".vest-wrapper-dots-dop").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".vest-wrapper-dop",
      arrows: false,
      dots: true,
    })
  }

  $("body").on("click", ".register-password-control", function () {
    if ($("#RegisterForm-password").attr("type") == "password") {
      $(this).addClass("view")
      $("#RegisterForm-password").attr("type", "text")
    } else {
      $(this).removeClass("view")
      $("#RegisterForm-password").attr("type", "password")
    }
    return false
  })

  $("body").on("click", ".password-control", function () {
    if ($("#CustomerPassword").attr("type") == "password") {
      $(this).addClass("view")
      $("#CustomerPassword").attr("type", "text")
    } else {
      $(this).removeClass("view")
      $("#CustomerPassword").attr("type", "password")
    }
    return false
  })

  $("body").on("click", ".new-password-control", function () {
    if ($("#password").attr("type") == "password") {
      $(this).addClass("view")
      $("#password").attr("type", "text")
    } else {
      $(this).removeClass("view")
      $("#password").attr("type", "password")
    }
    return false
  })

  $("body").on("click", ".confirm-password-control", function () {
    if ($("#password_confirmation").attr("type") == "password") {
      $(this).addClass("view")
      $("#password_confirmation").attr("type", "text")
    } else {
      $(this).removeClass("view")
      $("#password_confirmation").attr("type", "password")
    }
    return false
  })

  if ($(".press-wrapper").length > 0) {
    $(".press-wrapper").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: false,
      speed: 600,
      focusOnSelect: true,
      asNavFor: ".press-wrapper-dots",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    })

    $(".press-wrapper-dots").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".press-wrapper",
      arrows: false,
      dots: true,
    })
  }

  if ($(".vest-imonials_wrapper").length > 0) {
    $(".vest-imonials_wrapper").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: false,
      infinite: true,
      speed: 600,
      focusOnSelect: true,
      asNavFor: ".vest-imonials_wrapper_dots",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            dots: true,
          },
        },
      ],
    })

    $(".vest-imonials_wrapper_dots").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".vest-imonials_wrapper",
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="far fa-arrow-left"></i></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="far fa-arrow-right"></i></button>',
    })
  }

  if ($(".slider-wrapper").length > 0) {
    $(".slider-wrapper").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: false,
      infinite: true,
      speed: 600,
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="far fa-arrow-left"></i></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="far fa-arrow-right"></i></button>',
    })
  }

  if ($(".timeline-slider_wrap").length > 0) {
    $(".timeline-slider_wrap").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: false,
      asNavFor: ".timeline-slider_wrap-arrow",
      speed: 600,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    })

    $(".timeline-slider_wrap-arrow").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".timeline-slider_wrap",
      arrows: true,
      dots: false,
      infinite: false,
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="far fa-arrow-left"></i></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="far fa-arrow-right"></i></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            arrows: false,
          },
        },
      ],
    })
  }

  $(".vest-icons-slider_ins").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".vest-icons-slider_wrapper",
  })
  $(".vest-icons-slider_wrapper").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".vest-icons-slider_ins",
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 660,
        settings: {
          slidesToShow: 4.8,
        },
      },
    ],
  })

  if ($(".verified-reviews_slider-wrap").length > 0) {
    $(".verified-reviews_slider-wrap").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: true,
      infinite: true,
      speed: 600,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            arrows: false,
          },
        },
      ],
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="far fa-arrow-left"></i></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="far fa-arrow-right"></i></button>',
    })
  }

  if ($(".video-slider_wrap").length > 0) {
    $(".video-slider_wrap").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: false,
      infinite: true,
      speed: 600,
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="far fa-arrow-left"></i></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="far fa-arrow-right"></i></button>',
    })
    $('.custom-arrow--prev, .prev-bottom').click(function() {
      $(".video-slider_wrap").slick('slickPrev');
  });

  $('.custom-arrow--next, .next-bottom').click(function() {
    $(".video-slider_wrap").slick('slickNext');
  });
  }

  if ($(".icons-slider_wrapper").length > 0) {
    $(".icons-slider_wrapper").slick({
      slidesToShow: 8,
      slidesToScroll: 8,
      arrows: true,
      dots: true,
      infinite: false,
      speed: 600,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 7,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
      ],
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="svg-arrow_left"></i></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="svg-arrow_right"></i></button>',
    })
  }

  $("#best_button").click(function () {
    $(".best-slider .best-slider_slide:nth-child(n+5)").css("display", "block")
    $(".best-slider_button").css("display", "none")
  })

  /*
  $('.customer_change').click(function (event) {
    var href=$(this).attr('href');
    $('.customer_block').css('display','none');
    $(href).css('display','block'); 
     
  })
  */

  if ($(".travel-slider_wrapper").length > 0) {
    $(".travel-slider_wrapper").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: true,
      infinite: true,
      speed: 500,
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="far fa-arrow-left"></i></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="far fa-arrow-right"></i></button>',
    })
  }
  $(".our_team_block_item").click(function () {
    var id = $(this).data("id")
    var row = $(this).data("row")
    var count = $(this).data("count")
    if ($(this).hasClass("active")) {
      $(this).removeClass("active")
      $(".our_team_block_row_show").removeClass("active")
      $(".our_team_block_row_tablet").removeClass("active")
      $(".our_team_block_row_mob").removeClass("active")
      $(".our_team_block_row_show").html("")
      $(".our_team_block_row_tablet").html("")
      $(".our_team_block_row_mob").html("")
    } else {
      $(".our_team_block_item").removeClass("active")
      $(".our_team_block_row_show").removeClass("active")
      $(".our_team_block_row_tablet").removeClass("active")
      $(".our_team_block_row_mob").removeClass("active")
      $(".our_team_block_row_show").html("")
      $(".our_team_block_row_tablet").html("")
      $(".our_team_block_row_mob").html("")

      var text = $(this).find(".text").html()
      $(this).addClass("active")
      $("#our_team_block_row_show_" + id).addClass("active")
      $("#our_team_block_row_show_" + id).html(text)

      $("#our_team_block_row_tablet_" + id + "_" + row).addClass("active")
      $("#our_team_block_row_tablet_" + id + "_" + row).html(text)

      $("#our_team_block_row_mob_" + id + "_" + count).addClass("active")
      $("#our_team_block_row_mob_" + id + "_" + count).html(text)
    }
  })

  $(".goto_link").click(function (event) {
    event.preventDefault
    event.stopPropagation
    let link = $(this).attr("href")
    $("html, body").animate({ scrollTop: $(link).offset().top }, 1000)
  })

  var item = urlParam("title")
  const parsed_item = item
  // if (isNaN(parsed_item)) { parsed_item= 0; }
  if (parsed_item > "") {
    if (parsed_item == "store_title") {
      if ($("#store_title").length > 0) {
        $("html, body").animate({ scrollTop: $("#store_title").offset().top - 90 }, 1000)
      }
    }
    if (parsed_item == "our_title") {
      if ($("#our_title").length > 0) {
        $("html, body").animate({ scrollTop: $("#our_title").offset().top - 90 }, 1000)
      }
    }
    if (parsed_item == "timeline_title") {
      if ($("#timeline_title").length > 0) {
        $("html, body").animate({ scrollTop: $("#timeline_title").offset().top - 90 }, 1000)
      }
    }
    if (parsed_item == "values_title") {
      if ($("#values_title").length > 0) {
        $("html, body").animate({ scrollTop: $("#values_title").offset().top - 90 }, 1000)
      }
    }
  }

  if ($("#resellersmenu").length > 0) {
    $("html, body").animate({ scrollTop: $("#resellersmenu").offset().top - 70 }, 500)
  }

  if ($("#assistspage").length > 0) {
    //$('html, body').animate({scrollTop: $('#assistspage').offset().top-70}, 500);
  }

  if ($(".faq-block").length > 0) {
    var contact = urlParam("contact%5Bcount%5D")
    const parsed = parseInt(contact)
    if (isNaN(parsed)) {
      parsed = 0
    }
    if (parsed > 0) {
      $(".faq-block details").removeAttr("open")
      $("#details_id_" + parsed).attr("open", "")
      $("html, body").animate({ scrollTop: $("#details_id_" + parsed).offset().top - 100 }, 500)
    }

    var item = urlParam("item")
    const parsed_item = parseInt(item)
    if (isNaN(parsed_item)) {
      parsed_item = 0
    }
    if (parsed_item > 0) {
      $(".faq-block details").removeAttr("open")
      $("#details_id_" + parsed_item).attr("open", "")
      $("html, body").animate({ scrollTop: $("#details_id_" + parsed_item).offset().top - 100 }, 500)
    }
  }

  if ($(".loyalty_program_block").length > 0) {
    var item = urlParam("item")
    const parsed_item = parseInt(item)
    if (isNaN(parsed_item)) {
      parsed_item = 0
    }
    if (parsed_item > 0) {
      $(".faq-block details").removeAttr("open")
      $("#details_id_" + parsed_item).attr("open", "")
      $("html, body").animate({ scrollTop: $("#details_id_" + parsed_item).offset().top - 100 }, 500)
    }
  }

  if ($(".questions-section_block").length > 0) {
    var item = urlParam("item")
    const parsed_item = parseInt(item)
    if (isNaN(parsed_item)) {
      parsed_item = 0
    }
    if (parsed_item > 0) {
      $(".faq-block details").removeAttr("open")
      $("#details_id_" + parsed_item).attr("open", "")
      $("html, body").animate({ scrollTop: $("#details_id_" + parsed_item).offset().top - 100 }, 500)
    }
  }
})

/*
jQuery(document).ready(function ($) {
  if ($('.rellax').length) {
    var rellax = new Rellax('.rellax',{
      wrapper:'.home-menu-block_images'
    });	
    
    }
})
*/

jQuery(document).ready(function ($) {
  window.addEventListener("scroll", function (event) {
    var top = this.pageYOffset

    var layers = $(".rellax")
    var speed, yPos
    layers.each(function () {
      speed = $(this).attr("data-speed")
      var yPos = -((top * speed) / 100)
      $(this).attr("style", "transform: translate3d(0px, " + yPos + "px, 0px)")
    })
  })
})

jQuery(document).ready(function ($) {
  $(".article-template a").click(function () {
    var to = $($.attr(this, "href")).offset().top - 80

    $("html, body").animate(
      {
        scrollTop: to,
      },
      1000
    )

    return false
  })
  $(".search-modal .modal-overlay").click(function () {
    $(".search-modal").removeClass("active")
    $("body").removeClass("overflow-hidden")
  })

  $(document).on("keyup", function (e) {
    if (e.key == "Escape") {
      $(".search-modal").removeClass("active")
      $("body").removeClass("overflow-hidden")
    }
  })

  /*
$(document).mouseup(function (e){
		var div = $(".search-modal");
  if (div.hasClass('active')) {
		if (!div.is(e.target)
		    && div.has(e.target).length === 0) {
           
			$('.search-modal').removeClass('active')
			$('body').removeClass('overflow-hidden')
		} 
  }
	});
        */

  if ($(".product_features_items_items ul").length) {
    $(".product_features_items_items ul").slick({
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: false,
      vertical: true,
      speed: 600,
      focusOnSelect: true,
      infinite: true,
      asNavFor: ".product_features_items_slider ul",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            asNavFor: "",
          },
        },
      ],
    })

    $(".product_features_items_slider ul").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".product_features_items_items ul",
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      focusOnSelect: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: true,
            dots: true,
            asNavFor: "",
            prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="fal fa-angle-left"></i></button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="fal fa-angle-right"></i></button>',
          },
        },
      ],
    })
  }

  if ($(".multi_gallery_v2_items_items ul").length) {
    $(".multi_gallery_v2_items_items ul").slick({
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: false,
      vertical: true,
      speed: 600,
      focusOnSelect: true,
      infinite: true,
      asNavFor: ".multi_gallery_v2_slider ul",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            asNavFor: "",
          },
        },
      ],
    })

    $(".multi_gallery_v2_slider ul").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".multi_gallery_v2_items_items ul",
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      focusOnSelect: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            autoplay: false,
            arrows: true,
            dots: true,
            asNavFor: "",
            prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="fal fa-angle-left"></i></button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="fal fa-angle-right"></i></button>',
          },
        },
      ],
    })
  }

  if ($(".homepage_science_items_items ul").length) {
    $(".homepage_science_items_items ul").slick({
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: false,
      vertical: true,
      speed: 600,
      focusOnSelect: true,
      infinite: true,
      asNavFor: ".homepage_science_items_slider ul",
      responsive: [
        {
          breakpoint: 767,
          settings: {
            asNavFor: "",
          },
        },
      ],
    })

    $(".homepage_science_items_slider ul").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".homepage_science_items_items ul",
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      focusOnSelect: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows: true,
            dots: true,
            asNavFor: "",
            prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="fal fa-angle-left"></i></button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="fal fa-angle-right"></i></button>',
          },
        },
      ],
    })
  }

  if ($(".vest_science_items_items ul").length) {
    $(".vest_science_items_items ul").slick({
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: false,
      vertical: true,
      speed: 600,
      focusOnSelect: true,
      infinite: true,
      asNavFor: ".vest_science_items_slider ul",
      responsive: [
        {
          breakpoint: 767,
          settings: {
            asNavFor: "",
          },
        },
      ],
    })

    $(".vest_science_items_slider ul").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".vest_science_items_items ul",
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      focusOnSelect: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows: true,
            dots: true,
            asNavFor: "",
            prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="fal fa-angle-left"></i></button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="fal fa-angle-right"></i></button>',
          },
        },
      ],
    })
  }

  if ($(".reason_slider_items_items ul").length) {
    $(".reason_slider_items_items ul").slick({
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: false,
      vertical: true,
      speed: 600,
      focusOnSelect: true,
      infinite: true,
      asNavFor: ".reason_slider_items_slider ul",
      responsive: [
        {
          breakpoint: 991,
          settings: {
            asNavFor: "",
          },
        },
      ],
    })

    $(".reason_slider_items_slider ul").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".reason_slider_items_items ul",
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      focusOnSelect: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: true,
            dots: true,
            asNavFor: "",
            prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="fal fa-angle-left"></i></button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="fal fa-angle-right"></i></button>',
          },
        },
      ],
    })
  }

  //Scroll Animation
  $(window).on("scroll", max_scrollanimation)
  function max_scrollanimation() {
    let win_height_padded = $(window).height() * 1.1
    let scrolled = $(window).scrollTop()
    $(".scrollanimation:not(.animated)").each(function () {
      let $this = $(this),
        offsetTop = $this.offset().top

      if (scrolled + win_height_padded > offsetTop) {
        if ($this.data("timeout")) {
          window.setTimeout(function () {
            $this.addClass("animated " + $this.data("animation"))
          }, parseInt($this.data("timeout"), 7))
        } else {
          $this.addClass("animated " + $this.data("animation"))
        }
      }
    })
  }

  if ($(".our_story_fourth_slider").length) {
    $(".our_story_fourth_slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      focusOnSelect: true,
      asNavFor: ".our_story_fourth_slider_nav",
      autoplaySpeed: 3000,
    })

    $(".our_story_fourth_slider_nav").slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      focusOnSelect: true,
      asNavFor: ".our_story_fourth_slider",
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="far fa-arrow-left"></i></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="far fa-arrow-right"></i></button>',
      dotsClass: "custom_paging",
      customPaging: function (slider, i) {
        return "<span>" + (i + 1) + "</span>/" + slider.slideCount
      },
    })
  }

  if ($(".header_announement_slider").length > 0) {
    console.log("123")
    $(".header_announement_slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      focusOnSelect: true,
      arrows: false,
      vertical: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
    })
  }

  /*
    $('.sticky_add_to_cart').click(function () {
     $('#AddToCart').click();
  })    
  */

  if ($(".our-customers-header1").length) {
    setTimeout(init_customers_header1, 3000)
  }

  if ($(".our-customers-header2").length) {
    setTimeout(init_customers_header2, 3000)
  }

  $(".item_image_video.show_video").click(function () {
    $(this).find(".item_image").css("z-index", "1")
  })
  $(".add-to-comparable").click(function () {
    if ($(".compare-bar").hasClass("comparable-hidden")) {
      $("#smile-ui-container").css("display", "block")
      $("#gorgias-chat-container").css("display", "block")
      $("#zonos").css("display", "block")
    } else {
      $("#smile-ui-container").css("display", "none")
      $("#gorgias-chat-container").css("display", "none")
      $("#zonos").css("display", "none")
    }
  })

  $(".compare-products-actions .close-bar").click(function () {
    $("#smile-ui-container").css("display", "block")
    $("#gorgias-chat-container").css("display", "block")
    $("#zonos").css("display", "block")
  })
  $(".comparable-popup-close").click(function () {
    $("#smile-ui-container").css("display", "block")
    $("#gorgias-chat-container").css("display", "block")
    $("#zonos").css("display", "block")
  })
  $(".compare-popup ").click(function () {
    $("#smile-ui-container").css("display", "block")
    $("#gorgias-chat-container").css("display", "block")
    $("#zonos").css("display", "block")
  })

  $(".collection-tab-nav-item-first").click(function () {
    let id = $(this).data("id")
    $(".collection-tab-nav-item-first").removeClass("active")
    $(this).addClass("active")
    $(".weeklyselection-wrp .product-grid-first").removeClass("active")
    $("#weeklyselection-" + id).addClass("active")
  })

  $(".collection-tab-nav-item-second").click(function () {
    let id = $(this).data("id")
    $(".collection-tab-nav-item-second").removeClass("active")
    $(this).addClass("active")
    $(".weeklyselection-wrp .product-grid-second").removeClass("active")
    $("#weeklyselection-" + id).addClass("active")
  })

  $(".collection-tab-nav-item-second").click(function () {
    let id = $(this).data("id")
    $(".collection-tab-nav-item-second").removeClass("active")
    $(this).addClass("active")
    $(".vest-product-block-wrap-ins-img").removeClass("active")
    $("#product-" + id).addClass("active")
  })

  $(".collection-tab-nav-item-selector").click(function () {
    let id = $(this).data("id")
    $(".collection-tab-nav-item-selector").removeClass("active")
    $(this).addClass("active")
    $(".weeklyselection-wrp .product-grid-first.selector").removeClass("active")
    $("#weeklyselection-" + id).addClass("active")
  })

  $(".collection-tab-nav-item-selector-nav").click(function () {
    let id = $(this).data("id")
    $(".collection-tab-nav-item-selector-nav").removeClass("active")
    $(this).addClass("active")
    $(".weeklyselection-wrp .product-grid-first.selector").removeClass("active")
    $("#weeklyselection-" + id).addClass("active")
  })

  $(".vest-product-block-wrap-ins.item-1 .vest-product-block-wrap-ins-color").click(function () {
    let id = $(this).data("id")
    $(".vest-product-block-wrap-ins.item-1 .vest-product-block-wrap-ins-color").removeClass("active")
    $(this).addClass("active")
    $(".vest-product-block-wrap-ins.item-1 .vest-product-block-wrap-ins-img").removeClass("active")
    $(".vest-product-block-wrap-ins.item-1 #product-" + id).addClass("active")
  })

  $(".vest-product-block-wrap-ins.item-2 .vest-product-block-wrap-ins-color").click(function () {
    let id = $(this).data("id")
    $(".vest-product-block-wrap-ins.item-2 .vest-product-block-wrap-ins-color").removeClass("active")
    $(this).addClass("active")
    $(".vest-product-block-wrap-ins.item-2 .vest-product-block-wrap-ins-img").removeClass("active")
    $(".vest-product-block-wrap-ins.item-2 #product-" + id).addClass("active")
  })
})

function init_customers_header1() {
  jQuery(".our-customers-header1").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    arrows: false,
    easing: "linear",
    cssEase: "linear",
    waitForAnimate: false,
    speed: 8000,
    centerMode: true,
    edgeFriction: 0,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    autoSlidesToShow: true,
    variableWidth: true,
    touchMove: false,
    swipe: false,
  })
}

function init_customers_header2() {
  jQuery(".our-customers-header2").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    arrows: false,
    easing: "linear",
    cssEase: "linear",
    waitForAnimate: false,
    speed: 8000,
    centerMode: true,
    edgeFriction: 0,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    autoSlidesToShow: true,
    variableWidth: true,
    rtl: true,
    touchMove: false,
    swipe: false,
  })
}

jQuery(document).on("click", "#checkout", function (event) {
  if (jQuery("#carteffectiveAppsAgreeCBCart").length) {
    if (!document.getElementById("carteffectiveAppsAgreeCBCart").checked) {
      jQuery.fancybox.close()
      jQuery.fancybox.open({
        src: effective_apps_tac_alert,
        type: "html",
        baseClass: "effective_appsf_cart",
      })

      event.preventDefault
      event.stopPropagation
      return false
    }
  }

  jQuery("#cart").submit()
})

jQuery(document).on("click", ".cart__dynamic-checkout-buttons", function (event) {
  if (jQuery("#carteffectiveAppsAgreeCBCart").length) {
    if (!document.getElementById("carteffectiveAppsAgreeCBCart").checked) {
      jQuery.fancybox.close()
      jQuery.fancybox.open({
        src: effective_apps_tac_alert,
        type: "html",
        baseClass: "effective_appsf_cart",
      })

      event.preventDefault
      event.stopPropagation
      return false
    }
  } else {
    jQuery("#dynamic-checkout-cart").removeClass("noclickbut")
  }
})

function OnloadFunction() {
  if (jQuery(".cart__dynamic-checkout-buttons").length) {
    if (jQuery("#carteffectiveAppsAgreeCBCart").length) {
      if (!document.getElementById("carteffectiveAppsAgreeCBCart").checked) {
        jQuery("#dynamic-checkout-cart").addClass("noclickbut")
      } else {
        jQuery("#dynamic-checkout-cart").removeClass("noclickbut")
      }
    } else {
      jQuery("#dynamic-checkout-cart").removeClass("noclickbut")
    }
  }
}
jQuery(document).ready(OnloadFunction)

function carttermsAndConditionsCheckboxChanged() {
  if (jQuery(".cart__dynamic-checkout-buttons").length) {
    if (jQuery("#carteffectiveAppsAgreeCBCart").length) {
      if (!document.getElementById("carteffectiveAppsAgreeCBCart").checked) {
        jQuery("#dynamic-checkout-cart").addClass("noclickbut")
      } else {
        jQuery("#dynamic-checkout-cart").removeClass("noclickbut")
      }
    }
  }
}
